class Colors {
  constructor() {
    this.RGB_MAX = 255;
    this.HUE_MAX = 255;
    this.SV_MAX = 255;
  }

  rgb2Hsv(r, g, b, a) {
    if (typeof r === 'object') {
      var args = r
      r = args.r; g = args.g; b = args.b; a = args.a;
    }

    // It converts [0,255] format, to [0,1]
    r = (r === this.RGB_MAX) ? 1 : (r % this.RGB_MAX / parseFloat(this.RGB_MAX))
    g = (g === this.RGB_MAX) ? 1 : (g % this.RGB_MAX / parseFloat(this.RGB_MAX))
    b = (b === this.RGB_MAX) ? 1 : (b % this.RGB_MAX / parseFloat(this.RGB_MAX))
    a = a == undefined ? 1.0 : a;

    var max = Math.max(r, g, b)
    var min = Math.min(r, g, b)
    var h, s, v = max

    var d = max - min

    s = max === 0 ? 0 : d / max

    if (max === min) {
      h = 0 // achromatic
    } else {
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0)
          break
        case g:
          h = (b - r) / d + 2
          break
        case b:
          h = (r - g) / d + 4
          break
      }
      h /= 6
    }

    return {
      h: Math.floor(h * this.HUE_MAX),
      s: Math.floor(s * this.SV_MAX),
      v: Math.floor(v * this.SV_MAX),
      a: a
    }
  }

  hsv2Rgb(h, s, v, a) {
    if (typeof h === 'object') {
      var args = h
      h = args.h; s = args.s; v = args.v; a = args.a;
    }

    h = (h === this.HUE_MAX) ? 1 : (h % this.HUE_MAX / parseFloat(this.HUE_MAX) * 6)
    s = (s === this.SV_MAX) ? 1 : (s % this.SV_MAX / parseFloat(this.SV_MAX))
    v = (v === this.SV_MAX) ? 1 : (v % this.SV_MAX / parseFloat(this.SV_MAX))
    a = a == undefined ? 1.0 : a;

    var i = Math.floor(h)
    var f = h - i
    var p = v * (1 - s)
    var q = v * (1 - f * s)
    var t = v * (1 - (1 - f) * s)
    var mod = i % 6
    var r = [v, q, p, p, t, v][mod]
    var g = [t, v, v, q, p, p][mod]
    var b = [p, p, t, v, v, q][mod]

    return { r: Math.round(r * this.RGB_MAX), g: Math.round(g * this.RGB_MAX), b: Math.round(b * this.RGB_MAX), a: a}
  }

  rgb2Hex(r, g, b, a) {
    if (typeof r === 'object') {
      var args = r
      r = args.r; g = args.g; b = args.b; a = args.a;
    }
    r = Math.round(r).toString(16)
    g = Math.round(g).toString(16)
    b = Math.round(b).toString(16)
    a = Math.round(255*a).toString(16)

    r = r.length === 1 ? '0' + r : r
    g = g.length === 1 ? '0' + g : g
    b = b.length === 1 ? '0' + b : b
    a = a.length === 1 ? '0' + a : a

    return '#' + r + g + b + a
  }

  interpolate(a, b, t)
  {
    if(a == undefined || b == undefined)
      return {};
    // Hue interpolation
    var h;
    var h_a = a.h/parseFloat(this.HUE_MAX);
    var h_b = b.h/parseFloat(this.HUE_MAX);
    var d = (h_b - h_a);
    if (h_a > h_b)
    {
      // Swap (a.h, b.h)
      var h3 = h_b;
      h_b = h_a;
      h_a = h3;
      d = -d;
      t = 1 - t;
    }

    if (d > 0.5) // 180deg
    {
      h_a = h_a + 1; // 360deg
      h = ( h_a + t * (h_b - h_a) ) % 1; // 360deg
    }
    if (d <= 0.5) // 180deg
    {
      h = h_a + t * d
    }

    // Interpolates the rest
    return {
      h: Math.floor(this.HUE_MAX*h),
      s: Math.floor(a.s + t * (b.s-a.s)),
      v: Math.floor(a.v + t * (b.v-a.v)),
      a: a.a + t * (b.a-a.a)
    };
  }

  gradient(stops, t)
  {
    if(t > 1) t = 1.0;
    var color_a, color_b, d;
    for (var i = 0; i < stops.length; i++){     
      if(t>=stops[i].value){
        color_a = this.rgb2Hsv(stops[i].color);
        color_b = this.rgb2Hsv(stops[i+1].color);
        d = (t-stops[i].value)/(stops[i+1].value - stops[i].value);
      }
    }
    return this.hsv2Rgb(this.interpolate(color_a, color_b, d));
  }
}

let ColorUtils = new Colors();

export default ColorUtils;
